import React from 'react';

const UpdateConsignments = (props) => {
    
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // Prevent action if disabled
        if (!props.disabled) {
            props.onClickActive(props);
        }
    };

    return (
        <div className="map-icon-component" style={{ cursor: props.disabled ? "not-allowed" : "pointer" }}>
            {/* Conditionally render different icons based on iconType and disabled status */}
            {props.iconType === "edit" && !props.disabled ? (
                <img 
                    onClick={handleRouteClick}  
                    src={require("../../assets/images/Update.png")} 
                    style={{ height:"16px", color: "black" }}
                    alt="Edit" 
                   title= {props.tooltip==="Update Transporter"? "Edit Transporter": 'Edit'}
                />
            ) : (props.iconType === "edit" && props.disabled) ? (
                <img   
                    src={require("../../assets/images/update_disabled.png")} 
                    style={{ height:"16px", color: "gray" }}
                    alt="Edit" 
                    title='Edit'
                />
            ) : null}
        </div>
    );
};

export default UpdateConsignments;
